export default __webpack_public_path__ + "static/media/include_5_female@3x.52b6d232.jpg";